import type { WebchatTranslations } from '.'

export const ja: WebchatTranslations = {
  'composer.placeholder': 'メッセージを入力...',
  'composer.sendButton.ariaLabel': 'メッセージ送信ボタン',
  'composer.voiceButton.ariaLabel': '音声入力ボタン',
  'composer.fileButton.ariaLabel': 'ファイルアップロードボタン',
  'composer.messageInput.ariaLabel': 'メッセージ入力',

  'fileAttachment.uploadError': 'アップロードエラー',
  'fileAttachment.fallbackExtension': 'ファイル',
  'fileAttachment.removeButton.ariaLabel': 'ファイル削除ボタン',

  'header.defaultBotName': 'ボット',
  'header.expandButton.ariaLabel': 'ヘッダー展開ボタン',
  'header.sound.enable': 'チャット音を有効にする',
  'header.sound.disable': 'チャット音を無効にする',

  'conversationHistory.title': '会話履歴',
  'conversationHistory.empty': 'まだ会話がありません',
  'conversationHistory.newConversation': '新しい会話',
  'conversationHistory.sentAttachment': '添付ファイルを送信しました',
  'conversationHistory.showButton.ariaLabel': '最近の会話を表示ボタン',

  'restartConversation.title': '新しい会話を作成',
  'restartConversation.description': '現在の会話を消去し、新しい会話を開始します。',
  'restartConversation.confirm': '新しい会話',
  'restartConversation.cancel': 'キャンセル',
  'restartConversation.button.ariaLabel': '会話を再開ボタン',

  'closeButton.ariaLabel': 'チャットボットを閉じるボタン',

  'feedback.title': '改善にご協力ください',
  'feedback.description': 'サービス向上のため、フィードバックをお寄せください。',
  'feedback.confirm': 'フィードバックを送信',
  'feedback.cancel': 'キャンセル',
  'feedback.placeholder': '問題点をお知らせください...',

  'error.configuration': '設定エラー',
  'error.bot': 'ボットエラー',
  'error.network': 'ネットワークエラー',
  'error.disconnected': '切断されました',
  'error.unexpected': '予期しないエラー',

  'dropdown.placeholder': '選択...',
}
